export interface IssueType {
  id: string
  label: string
  description: string
}

export const ISSUE_TYPES: IssueType[] = [
  {
    id: 'BUG',
    label: 'Bug Report',
    description: 'Something is not working as expected',
  },
  {
    id: 'FEATURE_REQUEST',
    label: 'Feature Request',
    description: 'I have an idea for a new feature',
  },
  {
    id: 'QUESTION',
    label: 'Question',
    description: 'I need help understanding something',
  },
  {
    id: 'BILLING',
    label: 'Billing',
    description: 'Questions about invoices or payments',
  },
  {
    id: 'PLANS',
    label: 'Plans',
    description: 'Upgrade, downgrade, or change your plan',
  },
  {
    id: 'OTHER',
    label: 'Other',
    description: 'Something else',
  },
]
